
import React from 'react';
import '../todoList/todo/todo.css';
import { STATUS_OPTION } from './constants';
import { useSelector } from 'react-redux';
import { selectSelectedTodo } from './slice/buckets';

const BucketCard = ({ bucket, buckets }) => {
    const [orientation, setOrientation] = React.useState("bottom"); // Example orientation state
    const [darkTheme, setDarkTheme] = React.useState(false);
    const selectedTodo = useSelector(selectSelectedTodo);
    let fontColor = darkTheme ? "white" : "black";
    let titleFontSize = bucket.fontSizeAndStyle?.fontSize;
    let fontSize = 14;

    // Example: Use urgency or status for color
    const actionStatus = bucket.actionStatus || STATUS_OPTION.White;

    // Get all buckets from redux to find children
    const allBuckets = buckets
    const childBuckets = allBuckets.filter(b => b.parentRowID === bucket.rowID);
    const bucketIsSelected = selectedTodo && (selectedTodo.rowID === bucket.rowID);
    return (
        <div
            className={`${(orientation === "bottom") ? "forceCol" : (orientation === "top") ? "ReverseForceCol" : (orientation === "left") ? "ReverseForceRow" : "forceRow"} todoContainer`}
            style={{
                minWidth: 120,
                minHeight: 60,
                width: "100%",
                padding: 8,
                margin: 8,
                display: 'flex',
                position: 'absolute',
                overflow: 'hidden',
            }}
        >
            {/*backgroundColor: (selected && (selected.id == id)) ? "#F0F0F0" : props.darkTheme ? "#6305d0" : "white",
            fontWeight: props.todo.bold ? "bold !important" : "lighter !important",
                fontStyle: props.todo.italics ? "italic" : "unset",
            */}
            <div style={{
                minHeight: 50, minWidth: 100,
                margin: 0, height: "fit-content", zIndex: (((orientation === "top") || (orientation === "left")) ? 100 : 110),
                width: "100%",
                height: "100%",
                borderStyle: "solid",
                borderBottomColor: bucketIsSelected ? '#3b82f6' : 'rgb(250 250 250)',
                borderRightColor: bucketIsSelected ? '#3b82f6' : 'rgb(250 250 250)',
                borderTopColor: bucketIsSelected ? '#3b82f6' : 'rgb(250 250 250)',
                borderLeftColor: bucket.status,
                borderLeftWidth: "5px",
                borderRightWidth: "5px",
                borderBottomWidth: "5px",
                borderTopWidth: "5px",

                boxShadow: "1px 2px rgb(245 245 245)",
                color: darkTheme ? "white" : "#6305d0",
                paddingTop: "0px",

            }}>

                <div id="textContainer" style={{ height: "100%", color: fontColor }} >
                    <div key={bucket.rowID} style={{ fontSize: titleFontSize, color: fontColor, fontWeight: bucket.fontSizeAndStyle?.bold && "bold", fontStyle: bucket.fontSizeAndStyle?.italics && "italic" }} >
                        {bucket.name}
                    </div>
                    <div style={{ fontSize, backgroundColor: bucket.actionStatus, height: "20px" }} >
                        {bucket.points}
                    </div>
                    <div style={{ fontSize, backgroundColor: bucket.weekActionStatus, height: "20px" }} >
                        {bucket.weekPoints}
                    </div>
                    <div style={{ fontSize, backgroundColor: bucket.difficulty, height: "20px" }} >
                        difficulty
                    </div>
                    <div>
                        {childBuckets.length > 0 ? (
                            <div style={{ marginTop: 8 }}>
                                <strong>Child Buckets:</strong>
                                <ul style={{ margin: 0, paddingLeft: 16 }}>
                                    {childBuckets.map(child => (
                                        <li key={child.rowID}>
                                            <span style={{ color: fontColor, fontWeight: child.fontSizeAndStyle?.bold && "bold", fontStyle: child.fontSizeAndStyle?.italics && "italic" }}>  {child.name}</span>
                                            <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.status, width: "10px", height: "10px", display: "inline-block" }} />
                                            <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.actionStatus, width: "10px", height: "10px", display: "inline-block" }} />
                                            <div style={{ borderRadius: "50%", border: "solid 1px grey", backgroundColor: child.weekActionStatus, width: "10px", height: "10px", display: "inline-block" }} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default BucketCard;
